import axios from './axios-config';
import {
  IVerifyPartnerRequest,
  IMatchingUsersData,
  IDocumentSearch,
  IGroupAccountModel,
} from '../models/IRequestAccount';
import IRequestSubmissionData from '../models/IRequestSubmissionData';

export const rootURL =
  import.meta.env.VITE_ROOT_URL ??
  `${window.location.origin}/request-account/api`;

export const submitFormData = async (data: any) => {
  const url = `${rootURL}/submit`;
  return await axios.post(url, data);
};

export const submitFormDataToTestDb = async (data: any) => {
  const url = `${rootURL}/submit-to-test-db`;
  return await axios.post(url, data);
};

export const sendOTP = async (data: any) => {
  const url = `${rootURL}/send-otp`;
  return await axios.post(url, data);
};

export const verifyOTP = async (data: any) => {
  const url = `${rootURL}/verify-otp`;
  return await axios.post(url, data);
};

export const verifySponsorEmail = async (data: { sponsorEmail: string }) => {
  const url = `${rootURL}/verify-sponsor`;
  return await axios.post(url, data);
};

export const addSponsoredUsers = async (data: IGroupAccountModel) => {
  const url = `${rootURL}/group-add-users`;
  return await axios.post(url, data);
};

export const verifyAthenaPartnerDomain = async (
  data: IVerifyPartnerRequest
) => {
  const url = `${rootURL}/verify-partner-domain`;
  return await axios.post(url, data);
};

export const verifyAthenaRequestingUserEmail = async (
  data: IMatchingUsersData
) => {
  const url = `${rootURL}/verify-requesting-user-email`;
  return await axios.post(url, data);
};

export const searchByAuthorName = async (data: IDocumentSearch) => {
  const url = `${rootURL}/search/author`;
  return await axios.post(url, data);
};

export const mergeAthenaUsers = async (
  requestingUser: IRequestSubmissionData,
  matchingUsers: IMatchingUsersData[]
) => {
  const url = `${rootURL}/merge-users`;
  return await axios.post(url, {
    requestingUser,
    matchingUsers,
  });
};

export const addAthenaUser = async (requestingUser: IRequestSubmissionData) => {
  const url = `${rootURL}/add-user`;
  return await axios.post(url, requestingUser);
};

export const getAthenaKeywords = async () => {
  const url = `${rootURL}/athena-keywords`;
  return await axios.get(url);
};

export const migrateAccount = async (
  data: {
    CurrentEmail: string;
    NewEmail: string;
    Password: string;
  },
  userId: string
) => {
  const url = `${rootURL}/migrate-account?userId=${encodeURIComponent(userId)}`;
  return await axios.post(url, data);
};

export const getAthenaDownloadUrl = async (
  platform: 'windows-latest' | 'mac-latest'
) => {
  const url = `${window.location.origin}/athena/downloads/${platform}`;
  return await axios.get(url);
};

export const resetPassword = async (data: {
  email: string;
  newPassword: string;
}) => {
  const url = `${rootURL}/reset-password`;
  return await axios.post(url, data);
};